var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3320_343)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 2.75C12.1503 2.75026 12.375 2.83972 12.5449 3.00011C12.7148 3.1605 12.817 3.37971 12.8307 3.61295C12.8444 3.84618 12.7685 4.07585 12.6186 4.25501C12.4686 4.43418 12.2559 4.54932 12.0239 4.57692L11.9167 4.58333H4.58333V17.4167H17.4167V10.0833C17.4169 9.84969 17.5064 9.62497 17.6668 9.45508C17.8272 9.28519 18.0464 9.18295 18.2796 9.16926C18.5129 9.15557 18.7425 9.23145 18.9217 9.38141C19.1008 9.53137 19.216 9.74408 19.2436 9.97608L19.25 10.0833V17.4167C19.2501 17.8792 19.0755 18.3247 18.761 18.6638C18.4465 19.003 18.0154 19.2107 17.5542 19.2454L17.4167 19.25H4.58333C4.12081 19.2501 3.67531 19.0755 3.33616 18.761C2.99701 18.4465 2.78927 18.0154 2.75458 17.5542L2.75 17.4167V4.58333C2.74985 4.12081 2.92454 3.67531 3.23904 3.33616C3.55354 2.99701 3.98461 2.78927 4.44583 2.75458L4.58333 2.75H11.9167ZM17.6394 3.06442C17.8044 2.90001 18.0257 2.80457 18.2585 2.79746C18.4913 2.79035 18.7181 2.87211 18.8928 3.02614C19.0674 3.18018 19.1769 3.39492 19.199 3.62677C19.2211 3.85861 19.1541 4.09017 19.0117 4.27442L18.9356 4.3615L9.86058 13.4356C9.69562 13.6 9.47427 13.6954 9.24148 13.7025C9.00869 13.7097 8.78193 13.6279 8.60724 13.4739C8.43256 13.3198 8.32305 13.1051 8.30097 12.8732C8.27888 12.6414 8.34587 12.4098 8.48833 12.2256L8.56442 12.1394L17.6394 3.06442Z",
    fill: "#7E7E8B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3320_343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.1204d976b4ab061a378cdbeeb034780b.svg";
export { ForwardRef as ReactComponent };